const toggle = document.getElementById("toggle");
const range1 = document.getElementById('poopslide1');
const bubble1 = document.getElementById('poopsliderbubble1');

// need 3 types of savings: for water, price, usage 
// dont forget to implement theme as spans in calculateur.liquid
const literSavings = document.getElementById('literSavings');

// need to add the function to the range
// need more information about the money savings and usage
const moneySavings = document.getElementById('moneySavings');
const usageSavings = document.getElementById('usageSavings');


/* the range slider  start */
range1.addEventListener("input", () => {
    setBubble(range1, bubble1);
});

window.addEventListener('DOMContentLoaded', (event) => {
    setBubble(range1, bubble1);
});

window.addEventListener('resize', (event) => {
    setBubble(range1, bubble1);
});

function setBubble(range, bubble) {
    const val = range.value;
    const min = 0;
    const max = 6;
    const w   = range.offsetWidth;
    const tw  = 61;
    const xPX = (val-1) * (w - tw) / max;
    bubble.innerHTML = val;
    bubble.style.left = `${xPX}px`;

    discount();
}
/* the range slider  end */


const withoutDiscout = () =>{
    const utilisations = range1.value * 4.5;

    //nombre d'utilisations
    usageSavings.innerHTML = `${utilisations} <span class="spannlitre">utilisations </span>`

    // nombre d'euros par utilisations
    moneySavings.innerHTML = ` ${((10 * range1.value) / (4.5 * range1.value)).toFixed(2)}€ <span class="spannlitre">par utilisation </span>`

    //nombre de litres consommés pour le nombre d'utilisations dynamiques
    // en sachant qu'un collant standard = 4.5 utilisations
    literSavings.innerHTML = `${750 * (utilisations / 4.5)} <span class="spannlitre">Litres dépensés </span>`
};

const withDiscount = () =>{

    const utilisations = range1.value * 30;
    // nombres d'utilisations
    usageSavings.innerHTML = `${utilisations} <span class="spannlitre">utilisations </span>`

    // nombre d'euros par utilisations
    moneySavings.innerHTML = ` ${((26 * range1.value) / (30 * range1.value)).toFixed(2)}€ <span class="spannlitre">par utilisation </span>`

    //nombre de litres consommés pour le nombre d'utilisations dynamiques
    // en sachant qu'un cygne = 30 utilisations
    literSavings.innerHTML = `${750 * (utilisations / 30)} <span class="spannlitre">Litres dépensés </span>`
};

//choosing between price with Cygnes or without
function discount() {
    toggle.checked ?  withDiscount() : withoutDiscout();
}

range1.addEventListener("input",(e)=>{
    discount();
    
});
